import React, { createContext, useState } from 'react';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [ofertasData, setOfertasData] = useState([]);

  return (
    <DataContext.Provider value={{ ofertasData, setOfertasData }}>
      {children}
    </DataContext.Provider>
  );
};